import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useProductsByCatalogue = (catalogueName) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  console.log("catalogueName", catalogueName);
  useEffect(() => {
    if (catalogueName === null || catalogueName === undefined) return;
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const url = apiUrl(`products-by-catalogue/${catalogueName || "all"}`);
        console.log("url", url);
        //   const url = `/api/products-by-catalogue/${catalogueName || 'all'}`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const data = await response.json();
        console.log("data", data);
        setProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [catalogueName]);

  return { products, loading, error };
};

export default useProductsByCatalogue;
